module.exports = __webpack_public_path__ + "static/media/8、某市高速公路债务化解咨询-min.bc1915d1.jpg";